export default [
  'source',
  'custom',
  'percent',
  'fixedValue'
]



// WEBPACK FOOTER //
// ./src/storage/priceType.js